function getSlotElement(host, slotName) {
  const root = host.shadowRoot;
  if (!root) return null;
  const query = slotName ? `slot[name="${slotName}"]` : "slot:not([name])";
  return root.querySelector(query);
}
function querySlottedElements(host, slotName, options) {
  const slot = getSlotElement(host, slotName);
  if (!slot) return [];
  const flatten = options?.flatten ?? false;
  const elements = slot.assignedElements({ flatten });
  if (options?.selector) {
    return elements.filter((el) => el.matches(options.selector));
  }
  return elements;
}
function querySlottedNodes(host, slotName, options) {
  const slot = getSlotElement(host, slotName);
  if (!slot) return [];
  const flatten = options?.flatten ?? false;
  return Array.from(slot.assignedNodes({ flatten }));
}
function querySlottedElement(host, slotName, selector) {
  const elements = querySlottedElements(host, slotName, { selector });
  return elements[0] ?? null;
}
function hasSlottedContent(host, slotName) {
  return querySlottedElements(host, slotName, { flatten: true }).length > 0;
}
function hasSlottedElement(host, slotName, tagName) {
  const elements = querySlottedElements(host, slotName, { flatten: true });
  const upper = tagName.toUpperCase();
  return elements.some((el) => el.tagName === upper);
}
class SlotCache {
  constructor(host) {
    this.cache = /* @__PURE__ */ new Map();
    this.host = host;
  }
  getSlot(name) {
    const key = name ?? "";
    if (this.cache.has(key)) return this.cache.get(key);
    const slot = getSlotElement(this.host, name);
    this.cache.set(key, slot);
    return slot;
  }
  clear() {
    this.cache.clear();
  }
}
export {
  SlotCache,
  hasSlottedContent,
  hasSlottedElement,
  querySlottedElement,
  querySlottedElements,
  querySlottedNodes
};
//# sourceMappingURL=slot-query.js.map
